import React, { createContext, useEffect, useState } from 'react';
import {
  AnexoDemanda,
  Demanda,
  getAnexosDemanda,
  getDemanda,
  StepConclusao,
  getAnexoFormularioReqCompraApi,
  ItemContrato,
} from '@app/api/demanda';
import { GetPreSuprimentos, ParametrosPreSuprimentos } from '@app/api/configuracoes';
import { OptionProps, useRouter } from '@digital/ui';
import moment from 'moment';
import { verificarSeUsuarioAdministradorContrato } from '@app/api/usuario';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import { GetSasConsicaoPagamento, SasConsicaoPagamento } from '@app/api/sas/sasProposta';
import * as ui from '@digital/ui';
interface InitContextProps {
  templateContext: AnexoDemanda[];
  setTemplateContext(anexos: AnexoDemanda[]): Promise<void>;
  getTemplates(id: string | undefined): Promise<void>;
  anexoFormularioReqCompra: AnexoDemanda[];
  getAnexoFormularioReqCompra(id: string | undefined): Promise<void>;
  tipoDemanda: number | undefined;
  setTipoDemanda: React.Dispatch<React.SetStateAction<number | undefined>>;
  tipoContrato: string | undefined;
  setTipoContrato: React.Dispatch<React.SetStateAction<string | undefined>>;
  statusCodigo?: number;
  setStatusCodigo: React.Dispatch<React.SetStateAction<number | undefined>>;
  statusPrazo?: number;
  setStatusPrazo: React.Dispatch<React.SetStateAction<number | undefined>>;
  statusPrazoExtenso?: string;
  setStatusPrazoExtenso: React.Dispatch<React.SetStateAction<string | undefined>>;
  demandaData: Demanda | undefined;
  setDemandaData: React.Dispatch<React.SetStateAction<Demanda | undefined>>;
  descOi: string | undefined;
  setDescOi: React.Dispatch<React.SetStateAction<string | undefined>>;
  capex?: boolean;
  setCapex: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  opex?: boolean;
  setOpex: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  contaResultado?: boolean;
  setContaResultado: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  exibirModalFinalizarEtapaRequisicao: boolean;
  setExibirModalFinalizarEtapaRequisicao: React.Dispatch<React.SetStateAction<boolean>>;
  exibirModalFinalizarEtapaFaturamentoDireto: boolean;
  setExibirModalFinalizarEtapaFaturamentoDireto: React.Dispatch<React.SetStateAction<boolean>>;
  exibirModalSelectItemServico: boolean;
  setExibirModalSelectItemServico: React.Dispatch<React.SetStateAction<boolean>>;
  eliminacaoVisitaTecnica: boolean;
  setEliminacaoVisitaTecnica: React.Dispatch<React.SetStateAction<boolean>>;
  eliminacaoDirecionamentoFornecedor: boolean;
  setEliminacaoDirecionamentoFornecedor: React.Dispatch<React.SetStateAction<boolean>>;
  eliminacaoEmergencial: boolean;
  setEliminacaoEmergencial: React.Dispatch<React.SetStateAction<boolean>>;
  expectativaConclusao: moment.Moment | undefined;
  setExpectativaConclusao: React.Dispatch<React.SetStateAction<moment.Moment | undefined>>;
  stepsExpectativaConclusao: StepConclusao[];
  setStepsExpectativaConclusao: React.Dispatch<React.SetStateAction<StepConclusao[]>>;
  itemServicoOptions: OptionProps[] | undefined;
  setItemServicoOptions: React.Dispatch<React.SetStateAction<OptionProps[] | undefined>>;
  update: boolean;
  setUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  isEmergencial: boolean;
  setIsEmergencial: React.Dispatch<React.SetStateAction<boolean>>;
  isVisitaTecnica: boolean;
  setIsVisitaTecnica: React.Dispatch<React.SetStateAction<boolean>>;
  isFornecedorDirecionado: boolean;
  setIsFornecedorDirecionado: React.Dispatch<React.SetStateAction<boolean>>;
  justificativaEmergencia: string;
  setJustificativaEmergencia: React.Dispatch<React.SetStateAction<string>>;
  caracteristicaEmergencia: string[];
  setCaracteristicaEmergencia: React.Dispatch<React.SetStateAction<string[]>>;
  justificativaDirecionamento: string;
  setJustificativaDirecionamento: React.Dispatch<React.SetStateAction<string>>;

  codCentroDeCusto: string;
  setCodCentroDeCusto: React.Dispatch<React.SetStateAction<string>>;
  centroDeCusto: string;
  setCentroDeCusto: React.Dispatch<React.SetStateAction<string>>;
  codLotacaoDestino: string;
  setCodLotacaoDestino: React.Dispatch<React.SetStateAction<string>>;
  lotacaoDestino: string;
  setLotacaoDestino: React.Dispatch<React.SetStateAction<string>>;
  codOrdemInvestimento: string | null;
  setCodOrdemInvestimento: React.Dispatch<React.SetStateAction<string | null>>;
  ordemInvestimento: string;
  setOrdemInvestimento: React.Dispatch<React.SetStateAction<string>>;
  ordemManutencao: string | null;
  setOrdemManutencao: React.Dispatch<React.SetStateAction<string | null>>;
  itemServico: string | null;
  setItemServico: React.Dispatch<React.SetStateAction<string | null>>;

  valorAditivo: number;
  setValorAditivo: React.Dispatch<React.SetStateAction<number>>;
  isPrazo: boolean | undefined;
  setIsPrazo: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  isClausula: boolean | undefined;
  setIsClausula: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  isValorSemAcrescimoEscopo: boolean | undefined;
  setIsValorSemAcrescimoEscopo: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  isValorComAcrescimoEscopo: boolean | undefined;
  setIsValorComAcrescimoEscopo: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  isRemanejamentoVerbasEntreLinhas: boolean | undefined;
  setIsRemanejamentoVerbasEntreLinhas: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  isAcrescimoEscopoRemanejamentoVerba: boolean | undefined;
  setIsAcrescimoEscopoRemanejamentoVerba: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  requisicaoAbertaPeloDepPlanejamentoControle: boolean | undefined;
  setRequisicaoAbertaPeloDepPlanejamentoControle: React.Dispatch<React.SetStateAction<boolean | undefined>>;

  id: string | null;
  setId: React.Dispatch<React.SetStateAction<string | null>>;
  ordemCompraId: string | undefined;
  setOrdemCompraId: React.Dispatch<React.SetStateAction<string | undefined>>;
  requisicaoCompraId: string | undefined;
  setRequisicaoCompraId: React.Dispatch<React.SetStateAction<string | undefined>>;
  governancaAprovacaoId: string | undefined;
  setGovernancaAprovacaoId: React.Dispatch<React.SetStateAction<string | undefined>>;

  numeroContrato: string | undefined;
  setNumeroContrato: React.Dispatch<React.SetStateAction<string | undefined>>;
  numeroPcs: string | undefined;
  setNumeroPcs: React.Dispatch<React.SetStateAction<string | undefined>>;
  numeroContratoPcs: string | undefined;
  setNumeroContratoPcs: React.Dispatch<React.SetStateAction<string | undefined>>;
  prazoAtualPcs: string | undefined;
  setPrazoAtualPcs: React.Dispatch<React.SetStateAction<string | undefined>>;
  numeroPedido: string | null;
  setFornecedorContrato: React.Dispatch<React.SetStateAction<string | undefined>>;
  fornecedorContrato: string | undefined;
  setNumeroPedido: React.Dispatch<React.SetStateAction<string | undefined>>;

  exibirModalFinalizarEtapaDados: boolean;
  setExibirModalFinalizarEtapaDados: React.Dispatch<React.SetStateAction<boolean>>;
  exibirTabelaPrazo: boolean;
  setExibirTabelaPrazo: React.Dispatch<React.SetStateAction<boolean>>;

  diretoriaId: string | undefined;
  setDiretoriaId: React.Dispatch<React.SetStateAction<string | undefined>>;
  areaId: string | undefined;
  setAreaId: React.Dispatch<React.SetStateAction<string | undefined>>;
  departamentoId: string | undefined;
  setDepartamentoId: React.Dispatch<React.SetStateAction<string | undefined>>;

  concordaPrazo: boolean;
  setConcordaPrazo: React.Dispatch<React.SetStateAction<boolean>>;
  minAprovacaoGpc: number | undefined;
  parametrosPreSuprimentos: ParametrosPreSuprimentos | undefined;
  exibirModalEnviarPreSuprimentos: boolean;
  setExibirModalEnviarPreSuprimentos: React.Dispatch<React.SetStateAction<boolean>>;

  exibirModalEnviarValidacaoCapex: boolean;
  setExibirModalEnviarValidacaoCapex: React.Dispatch<React.SetStateAction<boolean>>;

  exibirModalEnviarValidacaoOpex: boolean;
  setExibirModalEnviarValidacaoOpex: React.Dispatch<React.SetStateAction<boolean>>;

  exibirModalEnviarValidacaoContaResultado: boolean;
  setExibirModalEnviarValidacaoContaResultado: React.Dispatch<React.SetStateAction<boolean>>;

  pacote: string;
  setPacote: React.Dispatch<React.SetStateAction<string>>;
  projeto: string;
  setProjeto: React.Dispatch<React.SetStateAction<string>>;
  validarAnexosObrigatorios: () => boolean;

  expectativaDePrazoConfirmacao: boolean;
  setExpectativaDePrazoConfirmacao: React.Dispatch<React.SetStateAction<boolean>>;
  haveraMaoDeObraEmPTRConfirmacao: boolean|undefined;
  setHaveraMaoDeObraEmPTRConfirmacao: React.Dispatch<React.SetStateAction<boolean|undefined>>;
  haveraSlaConfirmacao: boolean;
  setHaveraSlaConfirmacao: React.Dispatch<React.SetStateAction<boolean>>;
  haveraDespesasReembolsaveisConfirmacao: boolean;
  setHaveraDespesasReembolsaveisConfirmacao: React.Dispatch<React.SetStateAction<boolean>>;
  novoPrazoConfirmacao: boolean;
  setNovoPrazoConfirmacao: React.Dispatch<React.SetStateAction<boolean>>;
  isVisitaTecnicaConfirmacao: boolean;
  setIsVisitaTecnicaConfirmacao: React.Dispatch<React.SetStateAction<boolean>>;

  gestorTecnicoId: string | undefined;
  setGestorTecnicoId: React.Dispatch<React.SetStateAction<string | undefined>>;

  isAdmContrato: boolean;
  setIsAdmContrato: React.Dispatch<React.SetStateAction<boolean>>;

  isDemandante: boolean;
  setIsDemandante: React.Dispatch<React.SetStateAction<boolean>>;

  isGPC: boolean;
  setIsGPC: React.Dispatch<React.SetStateAction<boolean>>;

  caracteristicaContratacao: string | undefined;
  setCaracteristicaContratacao: React.Dispatch<React.SetStateAction<string | undefined>>;

  relacionamentoEntidadePublica: boolean | undefined;
  setRelacionamentoEntidadePublica: React.Dispatch<React.SetStateAction<boolean|undefined>>;

  tipoReavaliacao: number | undefined;
  setTipoReavaliacao: React.Dispatch<React.SetStateAction<number | undefined>>;

  objetoContratado: string | undefined;
  setObjetoContratado: React.Dispatch<React.SetStateAction<string | undefined>>;

  
  objetoContrato: string | undefined;
  setObjetoContrato: React.Dispatch<React.SetStateAction<string | undefined>>;

  justificativaContratacao: string | undefined;
  setJustificativaContratacao: React.Dispatch<React.SetStateAction<string | undefined>>;

  condicaoPagamento: string | undefined;
  setCondicaoPagamento: React.Dispatch<React.SetStateAction<string | undefined>>;

  valorTotalContrato: number | undefined;
  setValorTotalContrato: React.Dispatch<React.SetStateAction<number | undefined>>;

  vigencia: number | undefined;
  setVigencia: React.Dispatch<React.SetStateAction<number | undefined>>;

  valorPedido: number | undefined;
  setValorPedido: React.Dispatch<React.SetStateAction<number | undefined>>;

  tipoFaturamento: number | undefined;
  setTipoFaturamento: React.Dispatch<React.SetStateAction<number | undefined>>;

  sasCondicaoPagamento: SasConsicaoPagamento[];
  setSasCondicaoPagamento: React.Dispatch<React.SetStateAction<SasConsicaoPagamento[]>>;

  setSelectedItemCodigoContrato: React.Dispatch<React.SetStateAction<string | undefined>>;
  selectedItemCodigoContrato: string | undefined; 
  
  setSelectedOrdemCompra: React.Dispatch<React.SetStateAction<string | undefined>>;
  selectedOrdemCompra: string | undefined;

  setSelectedOrdemInvestimento: React.Dispatch<React.SetStateAction<string | undefined>>;
  selectedOrdemInvestimento: string | undefined;

  setIdentificadorPQ: React.Dispatch<React.SetStateAction<string | undefined>>;
  identificadorPQ: string | undefined;
}

const QuestionarioContext = createContext({} as InitContextProps);

export const QuestionarioContextProvider: React.FC = ({ children }) => {
  const { match } = useRouter();
  const [id, setId] = useState<string | null>(match.url.split('/')[3] == 'new' ? null : match.url.split('/')[3]);
  const [ordemCompraId, setOrdemCompraId] = useState<string | undefined>();
  const [requisicaoCompraId, setRequisicaoCompraId] = useState<string | undefined>();
  const [governancaAprovacaoId, setGovernancaAprovacaoId] = useState<string | undefined>();
  const [selectedItemContrato, setSelectedItemContrato] = useState<string | undefined>();
  
  const [selectedOrdemCompra, setSelectedOrdemCompra] = useState<string | undefined>();
  const [selectedOrdemInvestimento, setSelectedOrdemInvestimento] = useState<string | undefined>();

  const [templateContext, setTemplateContext] = useState<AnexoDemanda[]>([]);
  const [anexoFormularioReqCompra, setAnexoFormularioReqCompra] = useState<AnexoDemanda[]>([]);
  const [tipoDemanda, setTipoDemanda] = useState<number>();
  const [tipoContrato, setTipoContrato] = useState<string>();
  const [statusCodigo, setStatusCodigo] = useState<number | undefined>();
  const [statusPrazo, setStatusPrazo] = useState<number | undefined>();
  const [statusPrazoExtenso, setStatusPrazoExtenso] = useState<string | undefined>();
  const [demandaData, setDemandaData] = useState<Demanda | undefined>();
  const [descOi, setDescOi] = useState<string>();
  const [capex, setCapex] = useState<boolean | undefined>();
  const [opex, setOpex] = useState<boolean | undefined>();
  const [contaResultado, setContaResultado] = useState<boolean | undefined>();
  const [exibirModalFinalizarEtapaRequisicao, setExibirModalFinalizarEtapaRequisicao] = useState<boolean>(false);
  const [exibirModalFinalizarEtapaFaturamentoDireto, setExibirModalFinalizarEtapaFaturamentoDireto] = useState<boolean>(
    false,
  );
  const [exibirModalSelectItemServico, setExibirModalSelectItemServico] = useState(false);
  const [eliminacaoVisitaTecnica, setEliminacaoVisitaTecnica] = useState<boolean>(false);
  const [eliminacaoDirecionamentoFornecedor, setEliminacaoDirecionamentoFornecedor] = useState<boolean>(false);
  const [eliminacaoEmergencial, setEliminacaoEmergencial] = useState<boolean>(false);
  const [expectativaConclusao, setExpectativaConclusao] = useState<moment.Moment | undefined>();
  const [stepsExpectativaConclusao, setStepsExpectativaConclusao] = useState<StepConclusao[]>([]);
  const [itemServicoOptions, setItemServicoOptions] = useState<OptionProps[]>();
  const [update, setUpdate] = useState<boolean>(false);

  const [isEmergencial, setIsEmergencial] = useState<boolean>(false);
  const [isVisitaTecnica, setIsVisitaTecnica] = useState<boolean>(false);
  const [isFornecedorDirecionado, setIsFornecedorDirecionado] = useState<boolean>(false);
  const [isAdmContrato, setIsAdmContrato] = useState<boolean>(false);
  const [isDemandante, setIsDemandante] = useState<boolean>(false);
  const [isGPC, setIsGPC] = useState<boolean>(true);

  const [caracteristicaEmergencia, setCaracteristicaEmergencia] = useState<string[]>([]);
  const [justificativaEmergencia, setJustificativaEmergencia] = useState<string>('');
  const [justificativaDirecionamento, setJustificativaDirecionamento] = useState<string>('');

  const [codCentroDeCusto, setCodCentroDeCusto] = useState<string>('');
  const [centroDeCusto, setCentroDeCusto] = useState<string>('');
  const [codLotacaoDestino, setCodLotacaoDestino] = useState<string>('');
  const [lotacaoDestino, setLotacaoDestino] = useState<string>('');

  const [codOrdemInvestimento, setCodOrdemInvestimento] = useState<string | null>(null);
  const [ordemInvestimento, setOrdemInvestimento] = useState<string>('');
  const [ordemManutencao, setOrdemManutencao] = useState<string | null>(null);
  const [itemServico, setItemServico] = useState<string | null>(null);
  const [pacote, setPacote] = useState<string>('');
  const [projeto, setProjeto] = useState<string>('');
  const [numeroContrato, setNumeroContrato] = useState<string | undefined>('');
  const [numeroPcs, setNumeroPcs] = useState<string | undefined>('');
  const [numeroContratoPcs, setNumeroContratoPcs] = useState<string | undefined>('');  
  const [prazoAtualPcs, setPrazoAtualPcs] = useState<string | undefined>();
  const [numeroPedido, setNumeroPedido] = useState<string | null>('');

  const [fornecedorContrato, setFornecedorContrato] = useState<string | undefined>('');

  const [isPrazo, setIsPrazo] = useState<boolean | undefined>();
  const [isClausula, setIsClausula] = useState<boolean | undefined>();
  const [isValorSemAcrescimoEscopo, setIsValorSemAcrescimoEscopo] = useState<boolean | undefined>();
  const [isValorComAcrescimoEscopo, setIsValorComAcrescimoEscopo] = useState<boolean | undefined>();
  const [isRemanejamentoVerbasEntreLinhas, setIsRemanejamentoVerbasEntreLinhas] = useState<boolean | undefined>(false);
  const [isAcrescimoEscopoRemanejamentoVerba, setIsAcrescimoEscopoRemanejamentoVerba] = useState<boolean | undefined>(
    false,
  );
  const [requisicaoAbertaPeloDepPlanejamentoControle, setRequisicaoAbertaPeloDepPlanejamentoControle] = useState<
    boolean | undefined
  >();
  const [valorAditivo, setValorAditivo] = useState<number>(0);

  const [exibirModalFinalizarEtapaDados, setExibirModalFinalizarEtapaDados] = useState<boolean>(false);
  const [exibirTabelaPrazo, setExibirTabelaPrazo] = useState<boolean>(false);

  const [diretoriaId, setDiretoriaId] = useState<string | undefined>();
  const [areaId, setAreaId] = useState<string | undefined>();
  const [departamentoId, setDepartamentoId] = useState<string | undefined>();

  const [concordaPrazo, setConcordaPrazo] = useState(true);
  const [minAprovacaoGpc, setMinAprovacaoGpc] = useState<number | undefined>();
  const [parametrosPreSuprimentos, setParametrosPreSuprimentos] = useState<ParametrosPreSuprimentos | undefined>();
  const [exibirModalEnviarPreSuprimentos, setExibirModalEnviarPreSuprimentos] = useState<boolean>(false);
  const [exibirModalEnviarValidacaoCapex, setExibirModalEnviarValidacaoCapex] = useState<boolean>(false);
  const [exibirModalEnviarValidacaoOpex, setExibirModalEnviarValidacaoOpex] = useState<boolean>(false);
  const [exibirModalEnviarValidacaoContaResultado, setExibirModalEnviarValidacaoContaResultado] = useState<boolean>(
    false,
  );

  const [expectativaDePrazoConfirmacao, setExpectativaDePrazoConfirmacao] = useState(false);
  const [haveraMaoDeObraEmPTRConfirmacao, setHaveraMaoDeObraEmPTRConfirmacao] = useState<boolean|undefined>(undefined);
  const [haveraSlaConfirmacao, setHaveraSlaConfirmacao] = useState(false);
  const [haveraDespesasReembolsaveisConfirmacao, setHaveraDespesasReembolsaveisConfirmacao] = useState(false);
  const [novoPrazoConfirmacao, setNovoPrazoConfirmacao] = useState(false);
  const [isVisitaTecnicaConfirmacao, setIsVisitaTecnicaConfirmacao] = useState(false);
  const [gestorTecnicoId, setGestorTecnicoId] = useState<string | undefined>();
  const [caracteristicaContratacao, setCaracteristicaContratacao] = useState<string | undefined>();
  const [relacionamentoEntidadePublica, setRelacionamentoEntidadePublica] = useState<boolean | undefined>(undefined);
  const [tipoReavaliacao, setTipoReavaliacao] = useState<number | undefined>();

  const [tipoFaturamento, setTipoFaturamento] = useState<number | undefined>();
  const [valorPedido, setValorPedido] = useState<number | undefined>();
  const [vigencia, setVigencia] = useState<number | undefined>();
  const [valorTotalContrato, setValorTotalContrato] = useState<number | undefined>();
  const [condicaoPagamento, setCondicaoPagamento] = useState<string | undefined>();
  const [justificativaContratacao, setJustificativaContratacao] = useState<string | undefined>();
  const [objetoContratado, setObjetoContratado] = useState<string | undefined>();
  const [objetoContrato, setObjetoContrato] = useState<string | undefined>();
  const [sasCondicaoPagamento, setSasCondicaoPagamento] = useState<SasConsicaoPagamento[]>();
  const [identificadorPQ, setIdentificadorPQ] = useState<number | undefined>();

  async function getTemplates(id: string) {
    if (id) {
      const result = await getAnexosDemanda({
        demandaId: id,
        filtroExibir: false,
      });
      if (result) {
        setTemplateContext(result);
      }
    }
  }

  const validarAnexosObrigatorios = () => {
    const obrigatorios = templateContext.filter(item => item.obrigatorio);

    const faltando = obrigatorios.filter(item => !item.arquivoAtual /*|| !item.arquivoAtual.local*/);

    if (faltando.length > 0) {
      const nomes = faltando.map(item => `- ${item.descricaoDocumento}`).join('\n');
      ui.notification.error(`Os seguintes anexos obrigatórios estão faltando:\n${nomes}`);
      return false;
    }

    return true;
  };

  async function getAnexoFormularioReqCompra(id: string) {
    if (id) {
      const result = await getAnexoFormularioReqCompraApi(id);
      if (result) {
        setAnexoFormularioReqCompra(result);
      }
    }
  }

  useEffect(() => {
    GetSasConsicaoPagamento().then(result => {
      if (result) {
        setSasCondicaoPagamento(result);
      }
    });
  }, []);

  useEffect(() => {
    verificarSeUsuarioAdministradorContrato().then(result => {
      if (result) {
        setIsAdmContrato(result);
      }
    });
  }, []);

  useEffect(() => {
    GetPreSuprimentos().then(data => {
      if (data) {
        setMinAprovacaoGpc(data.preSuprimentosMinimoAnaliseGpc);
        setParametrosPreSuprimentos(data);
      }
    });

    if (id) {
      getDemanda(id).then(data => {
        if (data) {
          setDemandaData(data);
          if (data.ordemCompraId) {
            setOrdemCompraId(data.ordemCompraId);
          }
          if (data.requisicaoCompraId) {
            setRequisicaoCompraId(data.requisicaoCompraId);
          }
          if (data.governancaAprovacaoId) {
            setGovernancaAprovacaoId(data.governancaAprovacaoId);
          }
          if (data.gestorTecnicoId) {
            setGestorTecnicoId(data.gestorTecnicoId);
          }
          if (data.isDemandante) {
            setIsDemandante(data.isDemandante);
          }
          if (data.caracteristicaContratacao) {
            setCaracteristicaContratacao(data.caracteristicaContratacao);
          }
          if (data.tipoReavaliacao) {
            setTipoReavaliacao(data.tipoReavaliacao);
          }

          setIsGPC(
            (data.tipo == ETipoDemanda.NovaContratacao && data.expectativaValorFinal < (minAprovacaoGpc || 100000)) ||
              (data.tipo == ETipoDemanda.Aditivo && (data.novoValorFinal || 0) < (minAprovacaoGpc || 100000)),
          );
        }
      });
    }
  }, [update, id]);

  return (
    <QuestionarioContext.Provider
      value={{
        id,
        setId,
        ordemCompraId,
        setOrdemCompraId,
        requisicaoCompraId,
        setRequisicaoCompraId,
        governancaAprovacaoId,
        setGovernancaAprovacaoId,
        templateContext,
        setTemplateContext,
        getTemplates,
        anexoFormularioReqCompra,
        getAnexoFormularioReqCompra,
        tipoDemanda,
        setTipoDemanda,
        tipoContrato,
        setTipoContrato,
        statusCodigo,
        setStatusCodigo,
        statusPrazo,
        setStatusPrazo,
        statusPrazoExtenso,
        setStatusPrazoExtenso,
        demandaData,
        setDemandaData,
        descOi,
        setDescOi,
        capex,
        setCapex,
        opex,
        setOpex,
        contaResultado,
        setContaResultado,
        exibirModalFinalizarEtapaRequisicao,
        setExibirModalFinalizarEtapaRequisicao,
        exibirModalFinalizarEtapaFaturamentoDireto,
        setExibirModalFinalizarEtapaFaturamentoDireto,
        exibirModalSelectItemServico,
        setExibirModalSelectItemServico,
        eliminacaoVisitaTecnica,
        setEliminacaoVisitaTecnica,
        eliminacaoDirecionamentoFornecedor,
        setEliminacaoDirecionamentoFornecedor,
        eliminacaoEmergencial,
        setEliminacaoEmergencial,
        expectativaConclusao,
        setExpectativaConclusao,
        stepsExpectativaConclusao,
        setStepsExpectativaConclusao,
        itemServicoOptions,
        setItemServicoOptions,
        update,
        setUpdate,
        isEmergencial,
        setIsEmergencial,
        isVisitaTecnica,
        setIsVisitaTecnica,
        isFornecedorDirecionado,
        setIsFornecedorDirecionado,
        justificativaEmergencia,
        setJustificativaEmergencia,
        caracteristicaEmergencia,
        setCaracteristicaEmergencia,
        justificativaDirecionamento,
        setJustificativaDirecionamento,
        codCentroDeCusto,
        setCodCentroDeCusto,
        centroDeCusto,
        setCentroDeCusto,
        codLotacaoDestino,
        setCodLotacaoDestino,
        lotacaoDestino,
        setLotacaoDestino,
        codOrdemInvestimento,
        setCodOrdemInvestimento,
        ordemInvestimento,
        setOrdemInvestimento,
        ordemManutencao,
        setOrdemManutencao,
        itemServico,
        setItemServico,
        valorAditivo,
        setValorAditivo,
        isPrazo,
        setIsPrazo,
        isClausula,
        setIsClausula,
        isValorSemAcrescimoEscopo,
        setIsValorSemAcrescimoEscopo,
        isValorComAcrescimoEscopo,
        setIsValorComAcrescimoEscopo,
        numeroContrato,
        setNumeroContrato,
        fornecedorContrato,
        setFornecedorContrato,
        numeroPedido,
        setNumeroPedido,
        exibirModalFinalizarEtapaDados,
        setExibirModalFinalizarEtapaDados,
        exibirTabelaPrazo,
        setExibirTabelaPrazo,
        diretoriaId,
        setDiretoriaId,
        areaId,
        setAreaId,
        departamentoId,
        setDepartamentoId,
        concordaPrazo,
        setConcordaPrazo,
        minAprovacaoGpc,
        parametrosPreSuprimentos,
        exibirModalEnviarPreSuprimentos,
        setExibirModalEnviarPreSuprimentos,
        exibirModalEnviarValidacaoCapex,
        setExibirModalEnviarValidacaoCapex,
        exibirModalEnviarValidacaoOpex,
        setExibirModalEnviarValidacaoOpex,
        exibirModalEnviarValidacaoContaResultado,
        setExibirModalEnviarValidacaoContaResultado,
        isRemanejamentoVerbasEntreLinhas,
        setIsRemanejamentoVerbasEntreLinhas,
        isAcrescimoEscopoRemanejamentoVerba,
        setIsAcrescimoEscopoRemanejamentoVerba,
        requisicaoAbertaPeloDepPlanejamentoControle,
        setRequisicaoAbertaPeloDepPlanejamentoControle,
        pacote,
        setPacote,
        projeto,
        setProjeto,
        expectativaDePrazoConfirmacao,
        setExpectativaDePrazoConfirmacao,
        haveraMaoDeObraEmPTRConfirmacao,
        setHaveraMaoDeObraEmPTRConfirmacao,
        haveraSlaConfirmacao,
        setHaveraSlaConfirmacao,
        haveraDespesasReembolsaveisConfirmacao,
        setHaveraDespesasReembolsaveisConfirmacao,
        novoPrazoConfirmacao,
        setNovoPrazoConfirmacao,
        isVisitaTecnicaConfirmacao,
        setIsVisitaTecnicaConfirmacao,
        gestorTecnicoId,
        setGestorTecnicoId,
        isAdmContrato,
        setIsAdmContrato,
        isDemandante,
        isGPC,
        caracteristicaContratacao,
        setCaracteristicaContratacao,
        relacionamentoEntidadePublica,
        setRelacionamentoEntidadePublica,
        tipoReavaliacao,
        setTipoReavaliacao,
        objetoContratado,
        setObjetoContratado,
        objetoContrato,
        setObjetoContrato,
        justificativaContratacao,
        setJustificativaContratacao,
        condicaoPagamento,
        setCondicaoPagamento,
        valorTotalContrato,
        setValorTotalContrato,
        vigencia,
        setVigencia,
        valorPedido,
        setValorPedido,
        tipoFaturamento,
        setTipoFaturamento,
        sasCondicaoPagamento,
        validarAnexosObrigatorios,
        setSelectedItemCodigoContrato: setSelectedItemContrato,
        selectedItemCodigoContrato: selectedItemContrato,
        selectedOrdemCompra,
        setSelectedOrdemCompra,
        selectedOrdemInvestimento,
        setSelectedOrdemInvestimento,
        identificadorPQ,
        setIdentificadorPQ,
        setNumeroPcs,
        numeroPcs,
        setNumeroContratoPcs,
        numeroContratoPcs,
        prazoAtualPcs,
        setPrazoAtualPcs
      }}>
      {children}
    </QuestionarioContext.Provider>
  );
};

export default QuestionarioContext;
